module.exports = __webpack_public_path__ + "static/media/3792.a0d84aca.jpg";